import { render, staticRenderFns } from "./product-quantity.vue?vue&type=template&id=bd80981e&scoped=true"
import script from "./product-quantity.vue?vue&type=script&lang=js"
export * from "./product-quantity.vue?vue&type=script&lang=js"
import style0 from "./product-quantity.vue?vue&type=style&index=0&id=bd80981e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd80981e",
  null
  
)

export default component.exports